import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, CalendarCheck } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { whatsappLink, telLink, mapsLink } from "@/lib/contact";

export default function MobileCtaBar() {
  const settings = useSettings();
  const items = [
    { label: "Ara", icon: Phone, href: telLink(settings), testid: "mobile-cta-call" },
    { label: "WhatsApp", icon: MessageCircle, href: whatsappLink(settings), external: true, testid: "mobile-cta-whatsapp" },
    { label: "Yol", icon: MapPin, href: mapsLink(settings), external: true, testid: "mobile-cta-maps" },
  ];

  return (
    <div
      data-testid="mobile-sticky-cta"
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-4 border-t border-white/10 glass lg:hidden"
    >
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <a
            key={it.label}
            href={it.href}
            data-testid={it.testid}
            {...(it.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            className="flex flex-col items-center gap-1 py-2.5 text-white active:bg-white/5"
          >
            <Icon className="h-5 w-5 text-gold" />
            <span className="text-[10px] font-semibold uppercase tracking-wide">{it.label}</span>
          </a>
        );
      })}
      <Link
        to="/randevu"
        data-testid="mobile-cta-randevu"
        className="flex flex-col items-center gap-1 bg-gold py-2.5 text-black"
      >
        <CalendarCheck className="h-5 w-5" />
        <span className="text-[10px] font-bold uppercase tracking-wide">Randevu</span>
      </Link>
    </div>
  );
}
